
// region JS Imports

// region External Modules
import $ from "jquery"
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string

  transaction_history_table_container:  string
  transaction_history_table_row:        string
  transaction_history_table_button_row: string
  show_more_button:                     string
  latest_transactions:                  string

  transaction_history_table_flat_value:        string
  transaction_history_table_floor_value:       string
  transaction_history_table_full_value_pop_up: string
}
interface InputSelector {
  scope?: string

  transaction_history_table_container?:   string
  transaction_history_table_row?:         string
  transaction_history_table_button_row?:  string
  show_more_button?:                      string
  latest_transactions?:                   string

  transaction_history_table_flat_value?:        string
  transaction_history_table_floor_value?:       string
  transaction_history_table_full_value_pop_up?: string
}

const DEFAULT_SELECTOR = {
  scope: ".page--building-level-real-estate-transactions-page--desktop--transaction-history-section",

  transaction_history_table_container:  ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table",
  transaction_history_table_row:        ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table-content--item",
  transaction_history_table_button_row: ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table-button--row",
  show_more_button:                     ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table-see_more-button",
  latest_transactions:                  ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table-latest-transactions",

  transaction_history_table_flat_value:         ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table--flat-value",
  transaction_history_table_floor_value:        ".page--building-level-real-estate-transactions-page--desktop--transaction-history-table--floor-value",
  transaction_history_table_full_value_pop_up:  ".full-value-pop-up",
}


class TransactionHistory {
  protected selector: Selector

  protected $scope: JQuery

  protected $transaction_history_table_container:   JQuery
  protected $transaction_history_table_row:         JQuery
  protected $transaction_history_table_button_row:  JQuery
  protected $show_more_button:                      JQuery
  protected $latest_transactions:                   JQuery

  protected $transaction_history_table_flat_value:  JQuery
  protected $transaction_history_table_floor_value: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)

    this.$transaction_history_table_container = this.$scope.find(this.selector.transaction_history_table_container)
    this.$transaction_history_table_row = this.$scope.find(this.selector.transaction_history_table_row)
    this.$transaction_history_table_button_row = this.$scope.find(this.selector.transaction_history_table_button_row)
    this.$show_more_button = this.$scope.find(this.selector.show_more_button)
    this.$latest_transactions = this.$scope.find(this.selector.latest_transactions)

    this.$transaction_history_table_flat_value = this.$scope.find(this.selector.transaction_history_table_flat_value)
    this.$transaction_history_table_floor_value = this.$scope.find(this.selector.transaction_history_table_floor_value)

    this.bind_action()
  }

  protected bind_action() {
    let display_count = 0
    this.$show_more_button?.on("click", () => {
      this.$transaction_history_table_row.filter(".hide").each((_idx, el) => {
        if (display_count < 10) {
          $(el).removeClass("hide")
        }

        display_count += 1
      })

      display_count = 0

      if (this.$transaction_history_table_row.filter(".hide").length === 0) {
        this.$show_more_button?.hide()
        this.$latest_transactions?.show()
      }
    })

    this.$transaction_history_table_flat_value.each((_idx, el) => {
      const $el = $(el)

      $el.on("mouseover", (e) => {
        // only show pop up when total number of lines >= 3
        // each line's height is 16px
        const line_height = parseInt($(e.currentTarget).css("line-height")) || 0
        if ( e.currentTarget.scrollHeight > (line_height * 3) ) {
          const margin_top = e.currentTarget.clientHeight - e.currentTarget.scrollHeight + 16

          this.on_mouseover($el, margin_top)
        }
      })

      $el.on("mouseout", () => {
        this.on_mouseout($el)
      })
    })

    this.$transaction_history_table_floor_value.each((_idx, el) => {
      const $el = $(el)

      $el.on("mouseover", (e) => {
        // only show pop up when total number of lines >= 3
        // each line's height is 16px
        const line_height = parseInt($(e.currentTarget).css("line-height")) || 0
        if ( e.currentTarget.scrollHeight > (line_height * 3) ) {
          const margin_top = e.currentTarget.clientHeight - e.currentTarget.scrollHeight + 16

          this.on_mouseover($el, margin_top)
        }
      })

      $el.on("mouseout", () => {
        this.on_mouseout($el)
      })
    })
  }

  protected on_mouseover($el: JQuery<HTMLElement>, margin_top: number) {
    const $transaction_history_table_full_value_pop_up = $el.find(this.selector.transaction_history_table_full_value_pop_up)

    $transaction_history_table_full_value_pop_up.text($el.text())
    $transaction_history_table_full_value_pop_up.show()
    $transaction_history_table_full_value_pop_up.css("margin-top", margin_top)
  }

  protected on_mouseout($el: JQuery<HTMLElement>) {
    const $transaction_history_table_full_value_pop_up = $el.find(this.selector.transaction_history_table_full_value_pop_up)

    $transaction_history_table_full_value_pop_up.text("")
    $transaction_history_table_full_value_pop_up.hide()
  }

}

const Factory = {
  _instance: null as null | TransactionHistory,
  instance(selector?: InputSelector){
    if (this._instance !== null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new TransactionHistory(selector)
  },
}

export {
  Factory,
  TransactionHistory,
}
